import { useEffect, useState } from "react";
import Lenis from "lenis";
import Navbar from "@/components/site/Navbar";
import ScrollProgress from "@/components/site/ScrollProgress";
import Hero from "@/components/site/Hero";
import About from "@/components/site/About";
import Services from "@/components/site/Services";
import Process from "@/components/site/Process";
import Pricing from "@/components/site/Pricing";
import Testimonials from "@/components/site/Testimonials";
import Faq from "@/components/site/Faq";
import ContactInfo from "@/components/site/ContactInfo";
import CallbackForm from "@/components/site/CallbackForm";
import Footer from "@/components/site/Footer";

export default function Landing() {
  const [selectedPlan, setSelectedPlan] = useState(null);

  useEffect(() => {
    const lenis = new Lenis({ duration: 1.1, smoothWheel: true });
    let raf;
    const loop = (t) => { lenis.raf(t); raf = requestAnimationFrame(loop); };
    raf = requestAnimationFrame(loop);
    return () => { cancelAnimationFrame(raf); lenis.destroy(); };
  }, []);

  const choosePlan = (name) => {
    setSelectedPlan(name);
    document.querySelector("#rappel")?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <div className="bg-cream overflow-x-hidden">
      <ScrollProgress />
      <Navbar />
      <Hero />
      <About />
      <Services />
      <Process />
      <Pricing onChoose={choosePlan} />
      <Testimonials />
      <Faq />
      <ContactInfo />
      <CallbackForm selectedPlan={selectedPlan} clearPlan={() => setSelectedPlan(null)} />
      <Footer />
    </div>
  );
}
